import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ClientRepresentation} from '../models/ClientRepresentation';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    private readonly _realm: string;
    private readonly _version: string;
    private readonly _clientId: string;
    private readonly _oauthUrl: string;
    private readonly _keycloakUrl: string;
    private readonly _appPortal: ClientRepresentation;

    constructor() {
        this._realm = window['__env'].REALM;
        this._version = environment.version;
        this._oauthUrl = window['__env'].ENVIRONMENT_BASE_URL + '/oauth/api';
        this._clientId = window['__env'].OAUTH_CLIENT_ID;
        this._keycloakUrl = window['__env'].ENVIRONMENT_KEYCLOAK_BASE_URL + '/auth';
        this._appPortal = {
            id: null,
            name: 'PORTAL',
            attributes: new Map([
                ['icon', 'assets/images/applications/mobit.png'],
                ['url', window['__env'].ENVIRONMENT_BASE_URL]
            ])
        };
    }

    get realm(): string {
        return this._realm;
    }

    get version(): string {
        return this._version;
    }

    get appPortal(): ClientRepresentation {
        return this._appPortal;
    }

    get oauthUrl(): string {
        return this._oauthUrl;
    }

    get keycloakUrl(): string {
        return this._keycloakUrl;
    }

    get clientId(): string {
        return this._clientId;
    }

}